module.exports = __webpack_public_path__ + "img/于力.410854f0.jpg";